import { DndProvider } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';
import SchedulerComponent from './Scheduler';
import React from 'react';
import Box from '@mui/material/Box';
import {Header} from './Header';

const EventStaff = () => {

  return (
    <>
      <Box
        sx={{
          '& .scheduler-view': {
            background: '#fefefe !important',
          },
          '& .resource-view': {
            background: '#fefefe !important',
          },
          '& table.scheduler-bg-table th, table.scheduler-bg-table td': {
            background: '#fefefe !important',
            color: '#282828 !important',
          },
          '& .ant-row.ant-row-space-between.ant-row-middle': {
            marginBottom: '5px !important',
          },
          '& .react-big-schedule': {
            margin: '5px auto !important',
          },
          width: '100%',
        }}
      >
        <Header
          title={'Guide Scheduler'}
          hasPagination={false}
        />

        <SchedulerComponent />
      </Box>
    </>
  );
};

export default EventStaff;
